import { render, staticRenderFns } from "./trips-detail.vue?vue&type=template&id=aefbdc20&"
import script from "./trips-detail.vue.js?vue&type=script&lang=js&"
export * from "./trips-detail.vue.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports